(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 36566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85169);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31157);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45945);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47493);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17516);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);










var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({ displayName: "_error__BackgroundImage", componentId: "sc-1xzzcde-0" })(["background-image:", ";background-size:cover;background-position:center;min-height:551px;"],
function (props) {return props.url ? "url(".concat(props.url, ")") : null;});





var Layout = function Layout(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(BackgroundImage, { url: "/static/404-bg.jpg", children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
        flexDirection: "column",
        justifyContent: 'center',
        px: ['10px', '90px', '90px'],
        style: { height: '100%', minHeight: '550px' }, children: [/*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { width: [1, 1, 1 / 2], children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .H1Error */ .nL, { children: props.title }) }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { width: [1, 1, 1 / 2], mb: "30px", children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .PError */ .WF, { children: props.description }) }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { width: [1, 1, 1 / 2], children: props.actions })] }) }));};




var Error = function Error(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext[0],loading = _useContext[1].loading;

  if (loading) return null;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, { fullWidth: true, flexDirection: 'column', children:
      props.statusCode === 404 ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Layout, {
        backgroundImage: "/static/404-bg.jpg",
        title: "404",
        description: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
          currentUser ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.dear_visitor",
            message: "Dear {name}",
            values: {
              name: currentUser.firstName } }) : /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.dear_visitor",
            message: "Dear {name}",
            values: {
              name: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, { id: "metadata.visitor", message: "visitor" }) } }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("br", {}), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.body_404_part1",
            message: "You are trying to acces a page on Yogobe which does not seem to exist. Please email us" }), " ", /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: "mailto: info@yogobe.com", children: "info@yogobe.com" }), " ", /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.body_404_part2",
            message: "or use our search feature to find what it is you are looking for. Thank you for visiting Yogobe." })] }),



        actions: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
          appearance: "default-white",
          onClick: function onClick() {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/".concat(locale, "/me/dashboard"));
          }, children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, { id: "error.action", message: "Take me Home" }) }) }) : /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Layout, {
        backgroundImage: "/static/500-bg.jpg",
        title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, { id: "error.server_error", message: "Server Error" }),
        description: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
          currentUser ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.dear_visitor",
            message: "Dear {name}",
            values: {
              name: currentUser.firstName } }) : /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.dear_visitor",
            message: "Dear {name}",
            values: {
              name: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, { id: "metadata.visitor", message: "visitor" }) } }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("br", {}), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, {
            id: "error.body_500",
            message: "For some unworldly reason you have landed here. There seems to be a server error. Please refresh the page or try again in a short while. We also welcome you to help us out by reporting this!",
            components: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: "mailto:data@yogobe.com" }, "1")] })] }),



        actions: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { mx: "-5px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                appearance: "default-white",
                onClick: function onClick() {
                  next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/".concat(locale, "/me/dashboard"));
                }, children: /*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_9__/* .Trans */ .cC, { id: "error.action", message: "Take me Home" }) }) }) }) }) }) }));

























};

Error.getInitialProps = function (ctx) {
  var res = ctx.res,err = ctx.err;
  var statusCode = res ? res.statusCode : err ? err.statusCode : null;
  return { statusCode: statusCode };
};

Error.displayName = 'ErrorPage';

/* harmony default export */ __webpack_exports__["default"] = (Error);

/***/ }),

/***/ 52904:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(36566);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(52904); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);